import React, { useState, useEffect } from "react";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import { Popover, Typography } from "@mui/material";
import API_BASE_URL, { Providers } from "../../services/Config";
import axios from "axios";

const initialAccessState = [
    {
        name: "Registo de Consumos",
        isChecked: false,
        state: false,
        alias: "occurrence_registration",
    },
    {
        name: "Gestão Financeira",
        isChecked: false,
        state: false,
        alias: "financial_management",
    },
    {
        name: "Gestão Clinica",
        isChecked: false,
        state: false,
        alias: "clinical_management",
    },
];

const ShowComponent = ({ item, setMembers, members, setEditStatus }) => {
    const [openPopUpId1, setOpenPopUpId1] = useState(null);
    const [anchorElValue, setAnchorElValue] = useState(null);

    const token = localStorage.getItem("authToken");
    const [access, setAccess] = useState(initialAccessState);

    useEffect(() => {
        if (item?.tags) {
            const newAccess = access.map((item) => ({
                ...item,
                isChecked: false, // Reset all to false initially
                state: false,
            }));

            item.tags.forEach((tag) => {
                if (tag.includes("edit")) {
                    const alias = tag.split(".")[5];
                    const accessIndex = newAccess.findIndex(
                        (item) => item.alias === alias
                    );
                    if (accessIndex !== -1) {
                        newAccess[accessIndex].isChecked = true;
                        newAccess[accessIndex].state = true;
                    }
                } else if (tag.includes("view")) {
                    const alias = tag.split(".")[5];
                    const accessIndex = newAccess.findIndex(
                        (item) => item.alias === alias
                    );
                    if (accessIndex !== -1 && !newAccess[accessIndex].state) {
                        newAccess[accessIndex].isChecked = true;
                        newAccess[accessIndex].state = false;
                    }
                }
            });
            setAccess(newAccess);
        }
    }, [item]);
    const handlPopUpValue = (e, id) => {
        setAnchorElValue(e.currentTarget);
        setOpenPopUpId1(id);
    };

    const handlePopUpCloseValue = () => {
        setAnchorElValue(null);
        setOpenPopUpId1(null);
    };

    const setActive = () => {
        const index = members.findIndex((member) => member.id === item.id);

        // Create a new array with the updated item
        const newMembers = [...members];
        newMembers[index].status = 2;

        // Update the members state
        setMembers(newMembers);
    };
    const setEditState = () => {
        const index = members.findIndex((member) => member.id === item.id);

        // Create a new array with the updated item
        const newMembers = [...members];
        newMembers[index].status = 4;

        // Update the members state
        setMembers(newMembers);
        setEditStatus(true);
    };
    const removeItem = async () => {
        await axios
            .post(
                `${API_BASE_URL()}/v3/${Providers()}/provider-operators/${
                    item.id
                }/mark-as-canceled`,
                {},
                {
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                const newMembers = members?.map((member) =>
                    member.id === item.id
                        ? { ...member, state: "canceled" }
                        : member
                );
                setMembers(newMembers);
                handlePopUpCloseValue();
            })
            .catch((e) => {
                console.log(e);
            });
    };
    return (
        <div className="p-5 rounded-[11px] border-[1px] border-[#B2C3D4] flex flex-row w-full">
            <div className="flex flex-row justify-between w-4/12">
                <div className=" flex flex-col gap-[12px]   ">
                    <span className="font-14-700 text-[#697DA4] text-left">
                        {item?.name}
                    </span>
                    <span className="font-16-500 text-[#29215B]">
                        {item?.email}
                    </span>
                </div>
                <span className="w-[1px] h-[75%] bg-[#B2C3D4] mr-[25px] self-center"></span>
            </div>
            <div className="flex flex-row justify-between w-3/12">
                <div className="flex flex-col gap-[12px] ">
                    <span className="font-14-700 text-[#697DA4] text-left">
                        Entidades
                    </span>
                    <span className="font-16-500 text-[#29215B]">
                        {item?.distribution_points.length > 0
                            ? item?.distribution_points[0].distributionpoint
                                  ?.name +
                              (item?.distribution_points.length > 1
                                  ? "... +" +
                                    (item?.distribution_points.length - 1)
                                  : "")
                            : ""}
                    </span>
                </div>
                <span className="w-[1px] h-[75%] bg-[#B2C3D4] mr-[25px] self-center"></span>
            </div>
            <div className="flex flex-row justify-between w-3/12">
                <div className="flex flex-col gap-[12px] ">
                    <span className="font-14-700 text-[#697DA4] text-left">
                        Permissões de acesso
                    </span>
                    <span className="font-16-500 text-[#29215B]">
                        {access.some((item) => item.isChecked) ? (
                            access.find((item) => item.isChecked)?.name +
                            (access.filter((item) => item.isChecked).length > 1
                                ? "... +" +
                                  (access.filter((item) => item.isChecked)
                                      .length -
                                      1)
                                : "")
                        ) : (
                            <span className="font-16-500 text-[#95AFC9] self-center">
                                Selecionar...
                            </span>
                        )}
                    </span>
                </div>
                <span className="w-[1px] h-[75%] bg-[#B2C3D4] mr-[25px] self-center"></span>
            </div>
            <div className="flex flex-row justify-between w-2/12">
                <div className="flex flex-col gap-[12px]">
                    <span className="font-14-700 text-[#697DA4] text-left">
                        Estado
                    </span>
                    {item?.state !== "active" ? (
                        <button
                            className="flex flex-row gap-2 items-center"
                            onClick={() => setActive()}
                        >
                            <span className="h-[11px] w-[11px] rounded-full bg-[#F9BC04]"></span>
                            <span className="font-14-400 text-[#697DA4]">
                                Pendente...
                            </span>
                        </button>
                    ) : (
                        <button className="flex flex-row gap-2 items-center">
                            <span className="h-[11px] w-[11px] rounded-full bg-[#4CD964]"></span>
                            <span className="font-14-400 text-[#697DA4]">
                                Ativo
                            </span>
                        </button>
                    )}
                </div>
                <span className="w-[1px] h-[75%] bg-[#B2C3D4] mr-[15px] self-center"></span>
            </div>
            <button
                className="flex flex-col gap-[12px] self-center"
                onClick={(e) => handlPopUpValue(e, 1)}
            >
                <MoreVertOutlinedIcon
                    style={{ color: "#4A5568", height: "40px", width: "30px" }}
                />
            </button>
            <Popover
                id={1}
                open={openPopUpId1 === 1}
                anchorEl={anchorElValue}
                onClose={handlePopUpCloseValue}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                sx={{
                    marginTop: "1rem",
                    "& .MuiPaper-root": {
                        border: "1px solid #fff",
                        borderRadius: "1.1rem",
                        minWidth: "20rem",
                        boxShadow: "0px 0px 23px 0px rgba(0, 0, 0, 0.15)",
                    },
                }}
            >
                <Typography className="flex-column" style={{ width: "100%" }}>
                    <div className="flex flex-col gap-[8px] p-[18px] text-[#2F4369] text-left font-14-400">
                        <button
                            className="text-left"
                            onClick={() => setEditState()}
                        >
                            Editar
                        </button>
                        {item.state === "active" && (
                            <button
                                className="text-left"
                                onClick={(e) => handlPopUpValue(e, 2)}
                            >
                                Cancelar membro
                            </button>
                        )}
                    </div>
                </Typography>
            </Popover>

            <Popover
                id={2}
                open={openPopUpId1 === 2}
                anchorEl={anchorElValue}
                onClose={handlePopUpCloseValue}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                sx={{
                    marginTop: "-7rem",
                    "& .MuiPaper-root": {
                        border: "1px solid #fff",
                        borderRadius: "1.1rem",
                        minWidth: "30rem",
                        boxShadow: "0px 0px 23px 0px rgba(0, 0, 0, 0.15)",
                    },
                }}
            >
                <Typography className="flex-column" style={{ width: "100%" }}>
                    <div className="flex flex-col gap-[30px] p-[45px] text-[#2F4369] text-left font-16-600">
                        <span className="text-center">
                            Tem a certeza que deseja cancelar este membro?
                        </span>
                        <div className="flex flex-row gap-[19px]">
                            <button
                                className="rounded-[22px] w-[88px] h-[35px] bg-[#29215B] text-white"
                                onClick={() => handlePopUpCloseValue()}
                            >
                                NÃO
                            </button>
                            <button
                                className="rounded-[22px] w-[88px] h-[35px] bg-[#F2F5F8] text-[#29215B]"
                                onClick={() => removeItem()}
                            >
                                SIM
                            </button>
                        </div>
                    </div>
                </Typography>
            </Popover>
        </div>
    );
};

export default ShowComponent;
